<button [loading]="isLoading" [class]="buttonClass" (click)="onClick()" smsButton size="small" variant="outlined">
    <i [class]="'ph ph-download ' + iconClass"></i>
    Export Excel
</button>
